
import http from  './axios'
export const caseList = param =>{return http.post("clinic-manager/case/getHisByPage",param).then(res=>res.data.data)};
//病历列表
export const delCase = param =>{return http.post("clinic-manager/case/delHisCaseById",param).then(res=>res.data.data)};
//删除病历





// WEBPACK FOOTER //
// ./src/api/casemanage.js